exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.comments[data-v-6c8ff403] {\n  margin-bottom: 10px;\n}\n.comment[data-v-6c8ff403] {\n  margin: 30px 0;\n}\n", ""]);

// exports
